(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Shrink the overhanging logo once the page scrolls */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Close other <details> menus when one opens or on outside click */
  const detailsSel = '.site-nav__details, .header-search, .mobile-menu';
  document.addEventListener('click', (e) => {
    document.querySelectorAll(detailsSel).forEach((d) => {
      if (d.open && !d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(detailsSel).forEach((d) => {
      if (d.open) { d.removeAttribute('open'); d.querySelector('summary')?.focus(); }
    });
  });
  document.querySelectorAll('.header-search').forEach((d) => {
    d.addEventListener('toggle', () => { if (d.open) d.querySelector('input[type="search"]')?.focus(); });
  });

  /* Cart count + toast */
  const toast = document.getElementById('CartToast');
  let toastTimer;
  const showToast = (msg) => {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = msg;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4000);
  };
  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  };

  /* AJAX add to cart (falls back to normal form post on error) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || !window.fetch) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    btn?.classList.add('is-loading');
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      updateCount(cart.item_count);
      showToast(`Added: ${data.product_title || data.title}`);
    } catch (err) {
      showToast(err.message);
    } finally {
      btn?.classList.remove('is-loading');
    }
  });

  /* Product page: variant selection + gallery */
  document.querySelectorAll('.product-form').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const optionSelects = [...form.querySelectorAll('[data-option-index]')];
    if (!variantSelect || !optionSelects.length) return;
    const priceEl = document.querySelector('[data-product-price]');
    const addBtn = form.querySelector('[data-add-button]');
    const sync = () => {
      const chosen = optionSelects.map((s) => s.value).join('|');
      const match = [...variantSelect.options].find((o) => o.dataset.options === chosen);
      if (!match) { if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = 'Unavailable'; } return; }
      variantSelect.value = match.value;
      if (priceEl) priceEl.textContent = match.dataset.price;
      const available = match.dataset.available === 'true';
      if (addBtn) { addBtn.disabled = !available; addBtn.querySelector('span').textContent = available ? 'Add to cart' : 'Sold out'; }
      const url = new URL(window.location.href); url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url);
    };
    optionSelects.forEach((s) => s.addEventListener('change', sync));
  });

  /* Product gallery: thumbnails, arrows, keyboard and swipe */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (slides.length < 2) return;
    let current = 0;
    const show = (i) => {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, n) => { s.hidden = n !== current; s.classList.toggle('is-active', n === current); });
      thumbs.forEach((t, n) => (n === current ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
      thumbs[current]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(+t.dataset.galleryThumb)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
    let startX = null;
    const main = gallery.querySelector('.product-gallery__main');
    main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  });
})();
